import React, { ComponentType, SVGProps } from 'react'
import Button from '../Button'
import { CancelIcon24, DoneIcon32 } from '../../icons'
import Dialog from './Dialog'
import DialogContent from './DialogContent'
import DialogFooter from './DialogFooter'

export interface SimpleApplyCancelDialogProps {
  title: string
  state: boolean
  onApply: () => void
  onCancel: () => void
  applyButtonType?: 'button' | 'reset' | 'submit'
  applyButtonIcon?: ComponentType<SVGProps<SVGSVGElement>>
  applyButtonText: string
  applyButtonDisabled?: boolean
  cancelButtonText: string
  'data-testid': string
  children: React.ReactNode
}

export default function SimpleApplyCancelDialog({
  title,
  state,
  onCancel,
  onApply,
  applyButtonType = 'button',
  applyButtonIcon: ApplyButtonIcon = DoneIcon32,
  applyButtonText,
  applyButtonDisabled = false,
  cancelButtonText,
  'data-testid': testId,
  children
}: Readonly<SimpleApplyCancelDialogProps>) {
  return (
    <Dialog
      state={state}
      title={title}
      onClose={onCancel}
      className="max-w-2xl !p-1 !pt-1.5"
      data-testid={testId}
    >
      <DialogContent
        className="my-2 flex flex-col gap-1"
        data-testid={`${testId}-content`}
      >
        {children}
      </DialogContent>
      <DialogFooter data-testid={`${testId}-footer`}>
        <div
          className="flex flex-col gap-1"
          data-testid={`${testId}-footer-wrapper`}
        >
          <Button
            type={applyButtonType}
            variant="brand-primary"
            onClick={onApply}
            data-testid={`${testId}-apply-button`}
            disabled={applyButtonDisabled}
          >
            <ApplyButtonIcon data-testid={`${testId}-apply-button-icon`} />
            <span
              className="pl-0.5"
              data-testid={`${testId}-apply-button-text`}
            >
              {applyButtonText}
            </span>
          </Button>
          <Button
            type="button"
            variant="secondary-outline"
            onClick={onCancel}
            data-testid={`${testId}-cancel-button`}
          >
            <CancelIcon24
              className="shrink-0"
              data-testid={`${testId}-cancel-button-icon`}
            />
            <span
              className="pl-0.5"
              data-testid={`${testId}-cancel-button-text`}
            >
              {cancelButtonText}
            </span>
          </Button>
        </div>
      </DialogFooter>
    </Dialog>
  )
}
